import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";

import Navbar from "../common/Navbar";
import Footer from "../common/Footer";
import DigitalMarketingNoida from "../components/blogs/DigitalMarketingNoida";

const DigitalMarketingAgencyNoida = () => {
  const location = useLocation();

  useEffect(() => {
    if (!location.search) {
      window.scrollTo(0, 0);
    }
  }, [location]);

  return (
    <>
      <Helmet>
        <title>Digital Marketing agency in Noida | SMS ZOO ZOO</title>
        <meta
          name="description"
          content="SMS ZOO ZOO is a reliable digital marketing agency in Noida offering SEO, paid advertising, and lead generation for growing businesses."
        />

        <meta name="robots" content="index, follow" />
        <link
          rel="canonical"
          href="https://www.smszoozoo.com/digital-marketing-agency-noida"
        />
      </Helmet>

      <Navbar />
      <DigitalMarketingNoida />
      <Footer />
    </>
  );
};

export default DigitalMarketingAgencyNoida;
